import { render, staticRenderFns } from "./support.vue?vue&type=template&id=0faf0fa0&scoped=true"
var script = {}
import style0 from "./support.vue?vue&type=style&index=0&id=0faf0fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf0fa0",
  null
  
)

export default component.exports